import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=8d7abd40"
import script from "./UserDropdown.vue?vue&type=script&lang=ts"
export * from "./UserDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports